import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import * as yup from 'yup'

const inscriptionSchema = yup
  .object()
  .shape({
    first_name: yup.string(),
    last_name: yup.string(),
    phone: yup.number().typeError('Ajouter un numero de téléphone valide '),
    adresse: yup.string(),
    email: yup.string().required('email obligatoire'),
    password: yup
      .string()
      .required('Le mot de passe est obligatoire')
      .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
    passwordConfirmation: yup
      .string()
      .required('La confirmation du mot de passe est obligatoire')
      .oneOf([yup.ref('password')], 'Les mots de passe doivent correspondre')
  })
  .required();
  
const InscriptionProvider = ({children}) => {
  const methods = useForm({
    values:{
        first_name: '',
        last_name: '',     
        phone:'',
        adresse: '',
        email: '',
        password: '',
        passwordConfirmation: ''
    },
    defaultValues:{
        first_name: '',
        last_name: '', 
        phone:'',
        adresse: '',
        email: '',
        password: '',
        passwordConfirmation: ''
    },
    resolver:yupResolver(inscriptionSchema)
})
  return (
    <FormProvider {...methods}>{children}</FormProvider>
  )
}

export default InscriptionProvider